import { render, staticRenderFns } from "./CreateEditAgenda.vue?vue&type=template&id=468f6e40&scoped=true"
import script from "./CreateEditAgenda.vue?vue&type=script&lang=js"
export * from "./CreateEditAgenda.vue?vue&type=script&lang=js"
import style0 from "./CreateEditAgenda.vue?vue&type=style&index=0&id=468f6e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468f6e40",
  null
  
)

export default component.exports